import { render } from "./ChevronUpIcon16.vue.js?vue&type=template&id=4a3d998e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ChevronUpIcon16.vue?vue&type=template&id=4a3d998e"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__